import { CommonModule, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'haba-contentful-components';
import { I18nModule, UrlModule } from 'haba-core';

import { RouterModule } from '@angular/router';
import { FormFieldsModule } from '@app/base-components';
import { NewsletterSubscriptionSuccessComponent } from './newsletter-subscription-success/newsletter-subscription-success.component';
import { NewsletterComponent } from './newsletter/newsletter.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    ComponentsModule,
    UrlModule,
    FormFieldsModule,
    NgIf,
    NewsletterComponent,
    NewsletterSubscriptionSuccessComponent,
  ],
})
export class NewsletterModule {}
